// extracted by mini-css-extract-plugin
module.exports = {"sm":"0","md":"46.875rem","lg":"63.9375em","xl":"80em","section":"WhoAreWe_section__aLeGW","button":"WhoAreWe_button__SboHI"};